import React, { useState } from "react";
import "./DropdownModal.scss";
import IlifeModal2 from "./IlifeModal2";

function DropdownButton(props) {
  console.log("props", props);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
    setIsModalOpen(true);
  };
  return (
    <div className="dropdown-container">
      <button className="dropdown-button">
        {props.buttonText}
        <svg
          viewBox="0 0 24 24"
          width="24"
          height="24"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="white"
          onClick={handleClick}
        >
          <path d="M12 16l-6-6 12 0z" />
        </svg>
      </button>

      {isDropdownOpen && (
        <div className="dropdown-menus">
          {props.items.map((item) => (
            <div
              className="dropdown-itemss"
              key={item.id}
              onClick={() => props.onItemClick(item)}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
      {/* {isModalOpen && (
        <IlifeModal2 />

      )} */}
    </div>
  );
}

export default DropdownButton;
